// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#DOM_FT_PRIMARY_TOPLEVEL_mainContainer {
  z-index: 1 !important;
  margin-top: 2rem;
}

#DOM_FT_getReadyAndRetryScreenContainer > div > div {
  margin-top: -0.5rem !important;
}

#DOM_FT_getReadyAndRetryScreenContainer button {
  margin-bottom: 0.5rem !important;
}

#zoom-feedback {
  color: var(--dark) !important;
}

#DOM_FT_overlayContainer {
  background-color: var(--page-color) !important;
}

#DOM_FT_getReadyScreen {
  display: none !important;
}

#DOM_FT_getReadyActionButton {
  display: none !important;
}

#DOM_FT_retryInstructionsListContainer {
  margin-top: -1rem !important;
}

#DOM_FT_retryScreen .retry-action {
  width: auto !important;
  min-width: 17.5rem;
  height: 2rem !important;
  transform: translate(-50%, -100%) !important;
  z-index: 16777211;
  opacity: 1 !important;
  font-size: 0.875rem !important;
}

#DOM_FT_retryScreen .extra-action {
  width: auto !important;
  min-width: 17.5rem;
  height: 2rem !important;
  transform: translate(-50%, 18%) !important;
  z-index: 16777211;
  background: var(--button-additional-background) !important;
  color: var(--button-additional-color) !important;
  border: var(--button-additional-border) !important;
  font-size: 0.875rem !important;
}

#DOM_FT_retryScreenSubtextElement {
  white-space: normal;
}

#footerContainer {
  position: absolute;
  bottom: 0;
  display: flex;
  padding-bottom: 2rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-align: left;
  color: var(--text-contrast-color);
}

#footerContainer .mobileIcon {
  width: 40px;
  height: 30px;
}

#footerContainer .mobileIcon svg {
  height: 100%;
  width: auto;
}

#footerContainer .mobileIcon svg path {
  fill: var(--text-contrast-color);
}

#footerContainer .link {
  font-weight: 700;
  color: var(--brand);
  text-decoration: underline;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles/face-tec-override.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,iBAAiB;EACjB,0DAA0D;EAC1D,gDAAgD;EAChD,kDAAkD;EAClD,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":["#DOM_FT_PRIMARY_TOPLEVEL_mainContainer {\n  z-index: 1 !important;\n  margin-top: 2rem;\n}\n\n#DOM_FT_getReadyAndRetryScreenContainer > div > div {\n  margin-top: -0.5rem !important;\n}\n\n#DOM_FT_getReadyAndRetryScreenContainer button {\n  margin-bottom: 0.5rem !important;\n}\n\n#zoom-feedback {\n  color: var(--dark) !important;\n}\n\n#DOM_FT_overlayContainer {\n  background-color: var(--page-color) !important;\n}\n\n#DOM_FT_getReadyScreen {\n  display: none !important;\n}\n\n#DOM_FT_getReadyActionButton {\n  display: none !important;\n}\n\n#DOM_FT_retryInstructionsListContainer {\n  margin-top: -1rem !important;\n}\n\n#DOM_FT_retryScreen .retry-action {\n  width: auto !important;\n  min-width: 17.5rem;\n  height: 2rem !important;\n  transform: translate(-50%, -100%) !important;\n  z-index: 16777211;\n  opacity: 1 !important;\n  font-size: 0.875rem !important;\n}\n\n#DOM_FT_retryScreen .extra-action {\n  width: auto !important;\n  min-width: 17.5rem;\n  height: 2rem !important;\n  transform: translate(-50%, 18%) !important;\n  z-index: 16777211;\n  background: var(--button-additional-background) !important;\n  color: var(--button-additional-color) !important;\n  border: var(--button-additional-border) !important;\n  font-size: 0.875rem !important;\n}\n\n#DOM_FT_retryScreenSubtextElement {\n  white-space: normal;\n}\n\n#footerContainer {\n  position: absolute;\n  bottom: 0;\n  display: flex;\n  padding-bottom: 2rem;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  text-align: left;\n  color: var(--text-contrast-color);\n}\n\n#footerContainer .mobileIcon {\n  width: 40px;\n  height: 30px;\n}\n\n#footerContainer .mobileIcon svg {\n  height: 100%;\n  width: auto;\n}\n\n#footerContainer .mobileIcon svg path {\n  fill: var(--text-contrast-color);\n}\n\n#footerContainer .link {\n  font-weight: 700;\n  color: var(--brand);\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
